var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal custom",
      attrs: { id: "discard-from-changes", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog modal-md" }, [
        _c("div", { staticClass: "modal-content" }, [
          _vm._m(0),
          _vm._m(1),
          _c("div", { staticClass: "modal-footer xs-flex-column" }, [
            _c(
              "button",
              {
                staticClass: "btn cancel emergo-white-button xs-mb-10",
                attrs: { type: "button", "data-dismiss": "modal" },
              },
              [_vm._v(" Cancel ")]
            ),
            _c(
              "button",
              {
                staticClass: "btn emergo-green-button",
                attrs: { type: "button" },
                on: { click: _vm.discardChanges },
              },
              [_vm._v("Discard")]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header no-border" }, [
      _c("div", { staticClass: "col-xs-12 text-right p-0" }, [
        _c("img", {
          staticClass: "cursor-pointer",
          attrs: {
            "data-dismiss": "modal",
            src: "/static/images/icons/close_icon.svg",
            alt: "close-icon",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-body p-0 text-center row m-0" }, [
      _c("div", { staticClass: "col-xs-12 modal-body-text" }, [
        _c("img", {
          staticClass: "modal-title text-center mb-20",
          attrs: {
            src: "/static/images/icons/delete_warning.svg",
            alt: "delete-icon",
          },
        }),
        _c("p", { staticClass: "confirm_title text-center" }, [
          _vm._v("Are you sure you would like discard the changes? "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }